/**
 * @generated SignedSource<<df616b430b23a25936688a35419ae0d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type _sys_property_bulk_upload_input = {
  file_reference_source: string;
  file_source: string;
};
export type useUploadPropertyMutation$variables = {
  input: _sys_property_bulk_upload_input;
};
export type useUploadPropertyMutation$data = {
  readonly _sys_property_bulk_upload: {
    readonly added_property_codes: ReadonlyArray<string> | null;
    readonly duplicated_count: number;
    readonly updated_property_codes: ReadonlyArray<string> | null;
  } | null;
};
export type useUploadPropertyMutation = {
  response: useUploadPropertyMutation$data;
  variables: useUploadPropertyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "_sys_property_bulk_upload_output",
    "kind": "LinkedField",
    "name": "_sys_property_bulk_upload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "added_property_codes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updated_property_codes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duplicated_count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUploadPropertyMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUploadPropertyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ded2d9a8f1de52fedb1b1532090ec958",
    "id": null,
    "metadata": {},
    "name": "useUploadPropertyMutation",
    "operationKind": "mutation",
    "text": "mutation useUploadPropertyMutation(\n  $input: _sys_property_bulk_upload_input!\n) {\n  _sys_property_bulk_upload(input: $input) {\n    added_property_codes\n    updated_property_codes\n    duplicated_count\n  }\n}\n"
  }
};
})();

(node as any).hash = "00216625e635c7fe54bd67f82d43d9a8";

export default node;
